import profil from './profil.js'
import manajemenUsers from './manajemen-users.js'


const users = [...profil, ...manajemenUsers]

export default users